import React, { useState } from "react";
import { uploadBulkUsers } from "../api";
import Cookie from "js-cookie";

const emptyUser = () => ({
    firstName: "",
    lastName: "",
    email: "",
    job: "",
    industry: ""
});

const BulkUploadTab = (props) => {
    const [users, setUsers] = useState([emptyUser()]);
    const [numToAdd, setNumToAdd] = useState(1);
    const [loading, setLoading] = useState(false);
    const officeCode = Cookie.get("officeCode");

    const officeCodesCookie = Cookie.get("officeCodes") || "";
    const officeCodes = officeCodesCookie.split(",").map(code => code.trim()).filter(Boolean).sort();
    const [selectedOfficeCode, setSelectedOfficeCode] = useState(officeCodes[0] || "");

    const handleField = (idx, field, value) => {
        setUsers(users =>
            users.map((u, i) => (i === idx ? { ...u, [field]: value } : u))
        );
    };

    const handleAddRows = () => {
        setUsers(users => [...users, ...Array(Number(numToAdd)).fill().map(emptyUser)]);
    };

    const handleAddOne = () => setUsers(users => [...users, emptyUser()]);

    const handleDelete = idx => setUsers(users => users.filter((_, i) => i !== idx));

    const canSend = users.length > 0 && users.every(
        u => u.firstName.trim() && u.email.trim()
    ) && selectedOfficeCode;

    const handleSend = async () => {
        setLoading(true);
        try {
            const res= await uploadBulkUsers(selectedOfficeCode, users);
            setUsers([emptyUser()]);
            if (props.onSuccess) props.onSuccess(res?.data || "Invites sent!");
            // window.location.href = `?msg=${encodeURIComponent(res?.data || "Invites sent!")}&type=success`;

            // alert("Invites sent!");
        } catch {
            alert("Failed to send invites.");
        }
        setLoading(false);
    };

    return (
        <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
            <div className="flex justify-between items-end mb-4">
                <div className="flex gap-2 items-end">
                    <div>
                        <label className="block text-xs font-semibold mb-1">Number to Add</label>
                        <input
                            type="number"
                            min={1}
                            value={numToAdd}
                            onChange={e => setNumToAdd(e.target.value)}
                            className="border border-gray-300 rounded px-2 py-1 w-20"
                        />
                    </div>
                    <button
                        className="ml-2 px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                        onClick={handleAddRows}
                    >
                        Add
                    </button>
                </div>
                <div className="flex items-center">
                    <label className="mr-2 font-semibold text-xs">Office Code:</label>
                    <select
                        className="border border-gray-300 rounded px-2 py-1"
                        value={selectedOfficeCode}
                        onChange={e => setSelectedOfficeCode(e.target.value)}
                    >
                        {officeCodes.map(code => (
                            <option key={code} value={code}>{code}</option>
                        ))}
                    </select>
                </div>
            </div>


        {/*    <div className="mb-4 flex gap-2 items-end">*/}
        {/*        <div>*/}
        {/*            <label className="block text-xs font-semibold mb-1">Number to Add</label>*/}
        {/*            <input*/}
        {/*                type="number"*/}
        {/*                min={1}*/}
        {/*                value={numToAdd}*/}
        {/*                onChange={e => setNumToAdd(e.target.value)}*/}
        {/*                className="border border-gray-300 rounded px-2 py-1 w-20"*/}
        {/*            />*/}
        {/*        </div>*/}
        {/*        <button*/}
        {/*            className="ml-2 px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"*/}
        {/*            onClick={handleAddRows}*/}
        {/*        >*/}
        {/*            Add*/}
        {/*        </button>*/}

        {/*    </div><div className="flex justify-end mb-4">*/}
        {/*    <label className="mr-2 font-semibold text-xs">Office Code:</label>*/}
        {/*    <select*/}
        {/*        className="border border-gray-300 rounded px-2 py-1"*/}
        {/*        value={selectedOfficeCode}*/}
        {/*        onChange={e => setSelectedOfficeCode(e.target.value)}*/}
        {/*    >*/}
        {/*        {officeCodes.map(code => (*/}
        {/*            <option key={code} value={code}>{code}</option>*/}
        {/*        ))}*/}
        {/*    </select>*/}
        {/*</div>*/}
            <div className="overflow-x-auto">
                <table className="min-w-full text-fluid-sm">
                    <thead>
                    <tr className="bg-gray-50 border-b border-gray-200">
                        <th className="px-2 py-2 text-left font-semibold text-xs">First Name<span className="text-red-500">*</span></th>
                        <th className="px-2 py-2 text-left font-semibold text-xs">Last Name</th>
                        <th className="px-2 py-2 text-left font-semibold text-xs">Email<span className="text-red-500">*</span></th>
                        <th className="px-2 py-2 text-left font-semibold text-xs">Job Title</th>
                        <th className="px-2 py-2 text-left font-semibold text-xs">Industry</th>
                        <th className="px-2 py-2"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {users.map((u, idx) => (
                        <tr key={idx} className="border-b border-gray-100">
                            <td className="px-2 py-1">
                                <input
                                    className="border border-gray-300 rounded px-2 py-1 w-full"
                                    value={u.firstName}
                                    onChange={e => handleField(idx, "firstName", e.target.value)}
                                    required
                                />
                            </td>
                            <td className="px-2 py-1">
                                <input
                                    className="border border-gray-300 rounded px-2 py-1 w-full"
                                    value={u.lastName}
                                    onChange={e => handleField(idx, "lastName", e.target.value)}
                                />
                            </td>
                            <td className="px-2 py-1">
                                <input
                                    className="border border-gray-300 rounded px-2 py-1 w-full"
                                    value={u.email}
                                    onChange={e => handleField(idx, "email", e.target.value)}
                                    required
                                />
                            </td>
                            <td className="px-2 py-1">
                                <input
                                    className="border border-gray-300 rounded px-2 py-1 w-full"
                                    value={u.job}
                                    onChange={e => handleField(idx, "job", e.target.value)}
                                />
                            </td>
                            <td className="px-2 py-1">
                                <input
                                    className="border border-gray-300 rounded px-2 py-1 w-full"
                                    value={u.industry}
                                    onChange={e => handleField(idx, "industry", e.target.value)}
                                />
                            </td>
                            <td className="px-2 py-1">
                                <button
                                    className="text-red-500 hover:text-red-700"
                                    onClick={() => handleDelete(idx)}
                                    title="Delete"
                                >
                                    &#10005;
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div className="flex items-center justify-between mt-4">
                <div>
                    <button
                        className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600"
                        onClick={handleAddOne}
                    >
                        + Add Row
                    </button>
                </div>
                <div className="text-gray-700 text-sm">
                    Total fields: <span className="font-bold">{users.length}</span>
                </div>
                <div>
                    <button
                        className={`px-4 py-2 rounded text-white ${canSend ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-300 cursor-not-allowed"}`}
                        disabled={!canSend || loading}
                        onClick={handleSend}
                    >
                        {loading ? "Sending..." : "Send Invite"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BulkUploadTab;
